import React from 'react';
import { siteConfig } from '../config/siteConfig';
import ScrollingTitle from '../components/ScrollingTitle/ScrollingTitle';
import './Page.css';

const FilmserviceHistory = () => {
  const { title, subtitle, timeline, finalSection } = siteConfig.filmserviceHistory;

  return (
    <div className="page">
      <ScrollingTitle lines={title.lines} />
      
      <div className="history-page">
        <div className="history-subtitle">
          <h3>{subtitle}</h3>
        </div>
        
        <div className="timeline-sections">
          {timeline.map((item, index) => (
            <div key={index} className={`timeline-section ${index % 2 === 0 ? 'white-bg' : 'secondary-bg'}`}>
              <div className="timeline-section-container">
                <div className="timeline-left">
                  <div className="timeline-line"></div>
                  {Array.isArray(item.year) ? (
                    <div className="timeline-multiple-years">
                      {item.year.map((year, yearIndex) => (
                        <div key={yearIndex} className="timeline-year-circle">
                          {year}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="timeline-year-circle">
                      {item.year}
                    </div>
                  )}
                </div>
                <div className={`timeline-section-content ${index % 2 === 0 ? 'image-right' : 'image-left'}`}>
                  <div className="timeline-text-content">
                    <div className="timeline-section-text">
                      {item.content.split('\n\n').map((paragraph, pIndex) => (
                        <p key={pIndex}>{paragraph}</p>
                      ))}
                    </div>
                  </div>
                  {item.image && (
                    <div className="timeline-section-image">
                      <img 
                        src={item.image.src} 
                        alt={item.image.alt}
                        onError={(e) => {
                          e.target.src = `https://placehold.co/400x300/E63E96/FFFFFF?text=${encodeURIComponent(item.year)}`;
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Final Section - Text Only with Different Layout */}
        <div className="final-section">
          <div className="final-section-container">
            <div className="final-section-content">
              <div className="final-text-content">
                <p className="final-call-to-action">{finalSection.content.callToAction}</p>
                <p className="final-team-message">{finalSection.content.teamMessage}</p>
                <p className="final-closing">{finalSection.content.closing}</p>
                <div className="final-signature">
                  <p className="signature-name">{finalSection.content.signature.name}</p>
                  <p className="signature-title">{finalSection.content.signature.title}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilmserviceHistory; 